import React, { memo, PropsWithChildren } from "react";

import { Tabs } from "antd";

const { TabPane: AntdTabPane } = Tabs;

interface TabPaneProps {
  tab?: React.ReactNode | string;
  style?: React.CSSProperties;
  closable?: boolean;
  className?: string;
  disabled?: boolean;
  forceRender?: boolean;
  key?: string;
}

function TabPane(props: PropsWithChildren<TabPaneProps>): React.ReactElement {
  return <AntdTabPane {...props} />;
}

export default memo(TabPane);
